import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import GroupsLoader, { useGroups } from '../_load/GroupsLoader'

const GroupsFilterSideModal = ({ field, label, onClose, ...props }) => {
  const { t } = useTranslation('listGroups')
  field = field || 'groupIds'
  label = label || t('group')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <CheckboxesFilterSideModal
      label={label}
      value={value}
      dataHook={useGroups}
      onSubmit={handleChange(field)}
      Loader={GroupsLoader}
      useSearch
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      {...props}
    />
  )
}

export default GroupsFilterSideModal
